/*code reference from @material_ui component Dialog https://material-ui.com/components/dialogs/*/
/*And just like CustomDecisionPopup*/
import React from "react";
import TextTheme from "components/General/Text/TextTheme";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from '@material-ui/core/styles';
import MuiDialog from '@material-ui/core/Dialog';
import TwoButtonLayout from "components/General/Form/CustomButton/TwoButtonLayout";
import DialogContentText from "@material-ui/core/DialogContentText";
import CustomRadio from "components/General/Form/CustomRadio.js";
import * as CONSTANT from "constants/text";
/* Use hooks to store state in the function. */
import {useState} from 'react';


const CustomDialog = withStyles((theme) => ({
    paper: {
      borderRadius: "10px",
      padding: "8px",
    },
}))(MuiDialog);

function CustomInputPopup (props) {
    //hooks for radio
    const [radio1Checked, setChecked1] = useState(false);
    const [radio2Checked, setChecked2] = useState(false);
    const [error, setError] = useState(false);

    /* Validate that only one of the radios is checked before saving*/
    function validateInput(){
        if(!radio1Checked && !radio2Checked){
            setError(true);
        }
        // else call function providing the selcted radio value.
        else{
            if(radio1Checked){
                props.acceptButtonClick(props.radioValue1);
            }
            else if (radio2Checked){
                props.acceptButtonClick(props.radioValue2);
            }
        }
    };

    return(
        <div>
            <CustomDialog
                open = {true}
                onClose = {()=>(props.declineButtonClick())}
            >
                <DialogTitle>
                    <div style={{paddingBottom: "10px", borderBottom: "1.5px #e3e3e3 solid"}}>
                    <TextTheme
                        className = "text_bold text_medium text_dark_blue"
                        message = {props.popupTitle}
                    />
                    </div>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <TextTheme
                            className = "text_medium text_med_grey"
                            message = {props.popupDescription}
                        />
                    </DialogContentText>
                    <DialogContentText>
                        <TextTheme
                            className = "text_medium text_dark_blue"
                            message = {props.radioTitle}
                        />
                    </DialogContentText>

                    <div style = {{width: "370px"}}/>
                    <CustomRadio
                        type="radio"
                        id={props.radioValue1}
                        text={props.radioValue1}
                        name={props.radioValue1}
                        value={props.radioValue1}
                        handleChange={()=>{setChecked1(!radio1Checked);setChecked2(false);setError(false);}}
                        isChecked = {radio1Checked}
                    />
                    <label style={{width: "70px"}}/>
                    <CustomRadio
                        type="radio"
                        id={props.radioValue2}
                        text={props.radioValue2}
                        name={props.radioValue2}
                        value={props.radioValue2}
                        handleChange={()=>{setChecked1(false);setChecked2(!radio2Checked);setError(false);}}
                        isChecked = {radio2Checked}
                    />
                        {error?(
                            <DialogContentText>
                                <TextTheme
                                    className = "text_small text_red"
                                    message = {CONSTANT.ERROR_SELECT_A_ROLE}
                                />
                             </DialogContentText>
                          ):(null)
                        }
                </DialogContent>

                <DialogActions>
                    <div style = {{width: "55%", marginRight: "4%"}}>
                        <TwoButtonLayout button1Text={props.declineButtonText} button2Text={props.acceptButtonText}
                            button1Click={()=>(props.declineButtonClick())}
                            button2Click={()=>(validateInput())}
                            marginLeft = "0%"
                            marginRight = "8%"
                            width = "100%"
                        />
                    </div>
                </DialogActions>
            </CustomDialog>
        </div>
    );
}


export default CustomInputPopup;